module.exports = __webpack_public_path__ + "static/media/social-row.d8758205.jpg";